import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { formatINR } from "@/lib/format";
import { toast } from "sonner";
import { formatApiError } from "@/lib/format";

export default function Memberships() {
  const [plans, setPlans] = useState([]);
  const [mine, setMine] = useState([]);
  const [busyId, setBusyId] = useState(null);

  const load = async () => {
    const [a, b] = await Promise.all([
      api.get("/memberships"),
      api.get("/memberships/me"),
    ]);
    setPlans(a.data);
    setMine(b.data);
  };
  useEffect(() => {
    load();
  }, []);

  const purchase = async (id) => {
    setBusyId(id);
    try {
      await api.post("/memberships/purchase", { membership_id: id });
      toast.success("Membership activated");
      await load();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className="space-y-10" data-testid="memberships-page">
      <div>
        <div className="text-xs uppercase tracking-[0.22em] text-[#E8D6A3] mb-3">
          Memberships
        </div>
        <h1 className="text-4xl md:text-5xl font-black tracking-tighter">
          Pick your tier.
        </h1>
      </div>

      {mine.filter((m) => m.status === "active").length > 0 && (
        <div className="rounded-2xl border border-[#D4B878]/40 bg-[#D4B878]/5 p-5">
          <div className="text-xs uppercase tracking-[0.2em] text-[#E8D6A3] mb-2">
            Your active plans
          </div>
          <div className="flex flex-wrap gap-3">
            {mine.filter((m) => m.status === "active").map((m) => (
              <div
                key={m.id}
                className="rounded-xl border border-white/10 bg-black/40 px-4 py-2 text-sm"
              >
                <span className="font-bold">{m.plan_name}</span>{" "}
                <span className="text-zinc-500">· {m.remaining_hours}h left</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {plans.map((p) => (
          <div
            key={p.id}
            data-testid={`membership-plan-${p.tier}`}
            className="rounded-3xl border border-white/10 bg-white/[0.02] p-8 hover:bg-white/[0.04] transition flex flex-col"
          >
            <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">
              {p.tier}
            </div>
            <div className="text-3xl font-black mb-1">{p.name}</div>
            <div className="flex items-baseline gap-1 mt-5 mb-6">
              <span className="text-4xl font-black text-[#E8D6A3]">
                {formatINR(p.price)}
              </span>
              <span className="text-zinc-500 font-semibold">/mo</span>
            </div>
            <div className="text-sm text-zinc-400 mb-4">
              {p.included_hours} hrs included
            </div>
            <ul className="space-y-2 text-sm text-zinc-300 flex-1">
              {p.benefits.map((b) => (
                <li key={b} className="flex items-start gap-2">
                  <Check size={14} className="mt-1 text-[#E8D6A3]" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
            <Button
              onClick={() => purchase(p.id)}
              disabled={busyId === p.id}
              data-testid={`buy-plan-${p.tier}-btn`}
              className="mt-8 bg-[#D4B878] hover:bg-[#E8D6A3] rounded-full"
            >
              {busyId === p.id ? "Processing…" : "Activate"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
